"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterCode = void 0;
const KeyCodes_1 = __importDefault(require("@opsbase/lib-general/KeyCodes"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importStar(require("react"));
function EnterCode(props) {
    const { noOfParts = 4, partSize = 1, submitRef, onChange } = props;
    const values = (0, react_1.useRef)((0, range_1.default)(noOfParts).map(() => ''));
    const refs = (0, react_1.useRef)((0, range_1.default)(noOfParts).map(doNothing_1.default));
    const { forceUpdate } = (0, useForceUpdate_1.default)();
    const doGo = (0, react_1.useMemo)(() => n => {
        var _a;
        let focusable;
        if (n < 0)
            return;
        if (n >= noOfParts)
            focusable = submitRef;
        if (n < noOfParts)
            focusable = refs.current[n];
        if (focusable)
            (_a = focusable.focus) === null || _a === void 0 ? void 0 : _a.call(focusable);
    }, [noOfParts, submitRef]);
    const handleRef = (0, useCallforward_1.default)(n => ref => (refs.current[n] = ref), []);
    const handleKeyUp = (0, useCallforward_1.default)(n => e => {
        const c = e.keyCode;
        if (c === KeyCodes_1.default.TAB)
            return;
        if (c === KeyCodes_1.default.BACKSPACE) {
            values.current[n] = '';
            doGo(n - 1);
            forceUpdate();
            return;
        }
        if (c === KeyCodes_1.default.SHIFT)
            return;
        if (values.current[n].length === partSize)
            doGo(n + 1);
        forceUpdate();
    }, [doGo, forceUpdate, partSize]);
    const handleChange = (0, useCallforward_1.default)(n => v => {
        values.current[n] = v;
        const code = values.current.join('');
        if (code.length === noOfParts * partSize)
            onChange(code);
    }, [noOfParts, onChange, partSize]);
    return (react_1.default.createElement(Horizontal_1.default, { gutter: true }, (0, range_1.default)(noOfParts).map(n => (react_1.default.createElement(TextField_1.default, { key: 'code' + n, inputRef: handleRef(n), onKeyUp: handleKeyUp(n), inputProps: {
            maxLength: partSize,
            style: { fontSize: 24, textAlign: 'center' },
        }, value: values.current[n], onChange: handleChange(n) })))));
}
exports.EnterCode = EnterCode;
exports.default = EnterCode;
